import { HashRouter, Route, Routes } from 'react-router-dom';

import { LeftSidebar } from '../component/LeftSidebar';
import { MainNavigator } from '../component/MainNavigator';
import { SessionBox } from '../component/SessionBox';
import { CategoryPage } from './Category';
import { ClassificationTaskListPage } from './ClassificationTaskList';
import { TaskCreatorPage } from './CreateTask';
import { DashboardPage } from './Dashboard';
import { DocumentListPage } from './DocumentList';
import { DocumentUploadPage } from './DocumentUpload';
import { OptimizationTaskCreatorPage } from './OptimizationTaskCreator';
import { OptimizationTaskDetailPage } from './OptimizationTaskDetail';
import { ReportListPage } from './ReportList';
import { ReportTemplatePage } from './ReportTemplate';
import { ReportTemplateListPage } from './ReportTemplateList';
import { RuleListPage } from './RuleList';
import { SupervisionOrderListPage } from './SupervisionOrderList';
import { TaskListPage } from './TaskList';
import { WorkOrderListPage } from './WorkOrderList';

export const PageFrame = () => (
    <SessionBox>
        <MainNavigator />

        <HashRouter>
            <div className="d-flex">
                <LeftSidebar />
                <main
                    className="flex-fill"
                    style={{
                        height: 'calc(100vh - 4.7rem)',
                        overflowY: 'auto'
                    }}
                >
                    <Routes>
                        <Route path="/" element={<DashboardPage />} />
                        <Route path="/category" element={<CategoryPage />} />
                        <Route
                            path="/work-order"
                            element={<WorkOrderListPage />}
                        />
                        <Route
                            path="/document"
                            element={<DocumentListPage />}
                        />
                        <Route
                            path="/document/upload"
                            element={<DocumentUploadPage />}
                        />
                        <Route
                            path="/task/optimization/creator"
                            element={<OptimizationTaskCreatorPage />}
                        />
                        <Route
                            path="/task/:type/creator"
                            element={<TaskCreatorPage />}
                        />
                        <Route
                            path="/task/classification"
                            element={<ClassificationTaskListPage />}
                        />
                        <Route
                            path="/task/:type/:id"
                            element={<OptimizationTaskDetailPage />}
                        />
                        <Route path="/task/:type" element={<TaskListPage />} />
                        <Route path="/rule/:type" element={<RuleListPage />} />
                        <Route path="/report" element={<ReportListPage />} />
                        <Route
                            path="/report/template"
                            element={<ReportTemplateListPage />}
                        />
                        <Route
                            path="/report/template/:name"
                            element={<ReportTemplatePage />}
                        />
                        <Route
                            path="/supervision-order"
                            element={<SupervisionOrderListPage />}
                        />
                    </Routes>
                </main>
            </div>
        </HashRouter>
    </SessionBox>
);
